// extracted by mini-css-extract-plugin
export default {"main":"Main_main__LsqTk","h1":"Main_h1__CoSGz","control":"Main_control__nc9Wa","message":"Main_message__zCLz7","txtMessage":"Main_txtMessage__ZAJGy"};